import { render } from "./candidate_recommend.vue?vue&type=template&id=629f2dbe&scoped=true"
import script from "./candidate_recommend.vue?vue&type=script&lang=js"
export * from "./candidate_recommend.vue?vue&type=script&lang=js"

import "./candidate_recommend.vue?vue&type=style&index=0&id=629f2dbe&lang=scss&scoped=true"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629f2dbe"]])

export default __exports__